<template>
  <ComponentCard title="Dua" icon="solar:hand-stars-linear">
    <BlockField :model-value="attrs.title" placeholder="Title, like Morning dua" :read-only="readOnly" input-class="text-sm font-bold text-[#1c4848]" @update:model-value="set({ title: $event })" />
    <BlockField :model-value="attrs.arabic" arabic placeholder="الدعاء" :read-only="readOnly" input-class="text-[#1c4848]" @update:model-value="set({ arabic: $event })" />
    <BlockField :model-value="attrs.transliteration" placeholder="How to read it" :read-only="readOnly" input-class="text-sm italic text-[#1c4848]/70" @update:model-value="set({ transliteration: $event })" />
    <BlockField :model-value="attrs.translation" placeholder="What it means" :read-only="readOnly" input-class="text-[15px] leading-relaxed text-[#1c4848]" @update:model-value="set({ translation: $event })" />
    <div class="flex items-center gap-3">
      <div class="min-w-0 flex-1"><BlockField :model-value="attrs.source" placeholder="Source" :read-only="readOnly" input-class="text-xs font-semibold text-[#a0833c]" @update:model-value="set({ source: $event })" /></div>
      <label class="flex shrink-0 items-center gap-2 text-xs text-[#1c4848]/60">
        Say it
        <input :value="attrs.repeat" type="number" min="1" max="1000" :disabled="readOnly" class="w-16 rounded-lg border border-[#1c4848]/10 px-2 py-1 text-[#1c4848] outline-none" @input="set({ repeat: Math.max(1, Number($event.target.value) || 1) })">
        times
      </label>
    </div>
  </ComponentCard>
</template>

<script setup>
import BlockField from '@/components/writer/views/BlockField.vue';
import ComponentCard from '@/components/writer/views/ComponentCard.vue';

defineProps({ attrs: Object, readOnly: Boolean, context: Object, set: Function, kind: String });
</script>
